import IndividualAction from './IndividualAction';

export default IndividualAction;
